export default function openQuickOptions(flexPaneId: string) {
    const shim = (window as any).O365Shell;
    if (shim) {
        shim.FlexPane.OpenFlexPaneForProvider(flexPaneId);
    }
}
